import React from 'react';
import styled from 'styled-components';

import { pt, pb, px, mt } from 'styled-components-spacing';
import { map } from 'styled-components-breakpoint';

// this component has a visual next to content area on desktop
// on mobile, the image is always stacked on top
// Pass the `reverse` prop when using this component to enable flipping on desktop

const Container = styled.div`
  ${pt({ mobile: 4, tablet: 6 })};
  ${pb({ mobile: 2, tablet: 6 })};
  /* ${px(2)} */
  margin: 0 auto;
  ${mt({ mobile: 4, tablet: 8, desktop: 12 })};
  max-width: 1280px;
  display: grid;
  ${map(
    {
      mobile: '24px',
      tablet: '32px',
      desktop: '80px'
    },
    (gap) => `gap: ${gap};`
  )}
  align-items: center;
  justify-content: center;
  ${(props) =>
    map(
      {
        mobile: 'minmax(350px, 450px)',
        tablet: '0.7fr',
        desktop: `${props.reverse ? '1fr 0.8fr' : '0.8fr 1fr'}`
      },
      (cols) => `grid-template-columns: ${cols};`
    )};
  ${(props) =>
    map(
      {
        mobile: `'image' 'content'`,
        desktop: `${props.reverse ? "'content image'" : "'image content'"}`
      },
      (order) => `grid-template-areas: ${order};`
    )};
`;

const ImgContainer = styled.div`
  margin: 0 auto;
  grid-area: image;
  & > img {
    max-width: 100%;
  }
`;

const Content = styled.div`
  margin: 0 auto;
  grid-area: content;
`;

const ImageContent = (props) => {
  return (
    <Container {...props}>
      <ImgContainer>
        <props.ImgComponent />
      </ImgContainer>
      <Content>
        <props.ContentComponent />
      </Content>
    </Container>
  );
};

export default ImageContent;
